module.exports = __webpack_public_path__ + "files/dzs5.pdf";